import React from 'react';
import styled from 'styled-components';
import { Pie } from '../../../graphs';
import { RowWhite, ColumnHalf } from '../ui';
import { sortByLabels, getSelectedParcelsTitle } from '../selectors';
import { Loading } from '../loading';

export const Title = styled.strong`
  padding: 6px 0 6px 0;
  display: inline-block;
`;

export const PieChartElement = ({ city, reportContents, prop }) => {
  const graph = reportContents.graphs[prop.graph];
  const cityGraph = reportContents.graphs[`${prop.graph}_city`];
  const margin = {
    top: 6,
    right: 90,
    bottom: 70,
    left: 0,
  };

  if (!graph) {
    return <Loading />;
  }

  const map = prop.map || {};

  return (
    <ColumnHalf>
      <Title>{prop.label}</Title>
      <br />
      <RowWhite>
        <ColumnHalf style={{ height: 300, textAlign: 'center' }}>
          <span>{getSelectedParcelsTitle(reportContents)}</span>
          <Pie
            margin={margin}
            data={graph.data
              .filter(({ value }) => value > 0)
              .map((d) => ({
                value: d.value,
                label: map[d.column] || d.column,
                id: map[d.column] || d.column,
              }))
              .sort(sortByLabels)}
          />
        </ColumnHalf>
        {!cityGraph ? null : (
          <ColumnHalf style={{ height: 300, textAlign: 'center' }}>
            <span>{city}</span>
            <Pie
              margin={margin}
              data={cityGraph.data
                .filter(({ value }) => value > 0)
                .map((d) => ({
                  value: d.value,
                  label: map[d.column] || d.column,
                  id: map[d.column] || d.column,
                }))
                .sort(sortByLabels)}
            />
          </ColumnHalf>
        )}
      </RowWhite>
    </ColumnHalf>
  );
};
